module.exports = __webpack_public_path__ + "static/60-11ccafa0b78257c48dcf62d551e32ba4.png";